
/**
 * There is three way to use Miam's recipe counter 
 * 
 * 1 => Classic mode : threre is already a div with the id `miamMesRepas` in DOM 
 *      You just need to call an empty constructor then 
 *      example :
 *        new RecipeCounter();
 * 
 * 2 => Custom mode : We have to inject a wrapper ourself in DOM for our counter 
 *      We need a DOM element whitch 'll be the wrapper and second element already in DOM that 'll be use as a target.
 *      Our warpper 'll  inject juste before target
 *      example :     
 *        const template  = document.createElement('div');
 *        const injectBefore = document.getElementById('coraToolBar')
 *        new RecipeCounter({template, injectBefore});
 * 
 * 3 => Manual mode : 
 *      You can transphorm anything into a counter wrapper 
 *      example :
 *        const ourWarpper = getElementsByName('button')[0];
 *        ourWrapper.appendChild(RecipeCounter.initCounter(number))
 * 
 *      Or inject a custom warpper directly 
 *       example :
 *        const template  = document.createElement('div');
 *        const injectBefore = document.getElementById('coraToolBar')
 *        RecipeCounter.initCounterWrapperIfNeeded(number, template, injectBefore);
 * 
 *      Note that differences between manual mode, classique  and custom is that you
 *      have to initiate yourself subscription on Miam's basket stats 
 *     
 *      You can also use modes together 
 */
export class RecipeCounter {

  /**
   * Have to be a singleton
   * if not there 'll have severale subscription on miam's basket stats
   * @param {DOMelement} template to insert in DOM optional 
   * @param {DOMelement} toInjectBefore target in DOM optional 
   * template and toInjectBefore need eachother and have to be both pass as argument or not at all
   */
  constructor({template = null, toInjectBefore= null} = {} ) {
    RecipeCounter.initCounterWrapperIfNeeded(window.mealz.basket.recipeCount()?.value, template, toInjectBefore);
    window.mealz.basket.recipeCount().subscribe((recipeCount) => RecipeCounter.refreshRecipesCounters(recipeCount));
  }

  /**
   * Find first Element with id `miamMesRepas` inject a counter in clasique mode
   * In custom mode inject template beafore the target and add a counter inside
   * @param {number} recipeCount number use to initate counter 
   * @param {DOMelement} template to insert in DOM optional 
   * @param {DOMelement} toInjectBefore target in DOM optional 
   * template and toInjectBefore need eachother and have to be both pass as argument or not at all
   */
   static initCounterWrapperIfNeeded (recipeCount = 0, template = null, toInjectBefore = null) {
    let mesRepas = document.getElementById("miamMesRepas");

    if (!mesRepas  &&  !(template && toInjectBefore)) return;

    if(template && toInjectBefore){
      // in case of fragment element 
      mesRepas = template?.firstElementChild ? template.firstElementChild : template ; 
      toInjectBefore.parentNode.insertBefore(template, toInjectBefore);
    }

     mesRepas.style.position = 'relative';
     //to avoid init two times same wrapper
     mesRepas.setAttribute('id', 'miamMesRepasInit'); 
     const newCounter = RecipeCounter.initCounter(recipeCount);
     mesRepas.appendChild(newCounter);
  }

  /**
   * init a new counter element 
   * if recipeCounte is 0 will hide counter
   * @param {number} recipesCount number insert in counter
   * @returns a DOM elenemt
   */
   static initCounter(recipesCount = 0){

    const newCounter = document.createElement('span');

    if (recipesCount == 0) newCounter.classList.add('miam-hidden');

    newCounter.classList.add('miam-recipe-counter');
    newCounter.innerHTML = recipesCount;

    return newCounter;
  }

 
  /**
   * this function update all recipes's counter
   * @param {number} recipesCount number insert in counter
   * hide them if recipesCount is 0
   * show them if above
   */
   static refreshRecipesCounters(recipesCount = 0) {
  
    const counters = document.getElementsByClassName('miam-recipe-counter');
    if (!counters || counters.length === 0) return;
  
    for (let counter of counters){
      counter.innerHTML = recipesCount;
      recipesCount == 0 ? counter.classList.add('miam-hidden') : counter.classList.remove('miam-hidden')
    }
  }
}
